import $ from 'jquery';
$(document).ready(function() {
});

window.onload = function() {
    const MODAL_BACK_MANAGER_KEY = '__heliosModalBackManager';
    const getModalBackManager = () => {
        if (!window[MODAL_BACK_MANAGER_KEY]) {
            window[MODAL_BACK_MANAGER_KEY] = { depth: 0, ignoreNextPop: false };
        }
        return window[MODAL_BACK_MANAGER_KEY];
    };

    var $clone = "";
    var $lastelement = "";
    var lastelement = {
        'top': 0,
        'left': 0,
        'width': 0,
        'height': 0
    };
    var cloneflipped = false;
    var isExpanded = false;

    // Some of these properties (transition/transform/opacity) are also touched by
    // existing stylesheet rules. Writing them with !important guarantees our timing
    // wins regardless of selector specificity elsewhere, so the animation can't be
    // silently short-circuited.
    const setImportant = ($el, styles) => {
        $el.each(function () {
            Object.keys(styles).forEach((prop) => {
                this.style.setProperty(prop, styles[prop], 'important');
            });
        });
        return $el;
    };
    
    $(document).on("transitionend webkitTransitionEnd oTransitionEnd touchend", '#expandCard', function (e) {
        if (e.target === e.currentTarget || $(e.target).is('img.extend-modal-close.modal-close')) {
            if (e.originalEvent.propertyName == 'top' || e.originalEvent.type == 'touchend') {
                if ($(e.target).is('img.extend-modal-close.modal-close')) {
                    isExpanded = false
                    $('.expandCardBack').click();
                }
                cloneflipped = !cloneflipped;
                if (!cloneflipped) {
                    $($lastelement).css({'opacity': 1});
                    $($clone).hide();
                    $(".expandcard-header").hide();
                } else {
                }
            }
        }
    });

    $( document ).on( "click", ".drag_drop-card, .job-item", function(e) {
        e.preventDefault()
        $clone = $('#expandCard');

        if (!cloneflipped) {
            isExpanded = true;
            $lastelement = $(this);

            var offset = $lastelement.offset();
            lastelement.top = offset.top - $(document).scrollTop();
            lastelement.left = offset.left;
            lastelement.width = $lastelement.width();
            lastelement.height = $lastelement.height();

            $clone.css({
                'display': 'flex',
                'top': lastelement.top,
                'left': lastelement.left,
                'transform': 'unset',
                'width': '190px',
                'height': '97.5px'
            });
            $lastelement.animate({ opacity: 0 }, 150);
            var vpWidth = document.documentElement.clientWidth;
            var vpHeight = document.documentElement.clientHeight;
            $(".card-color-line").show();
            $(".expandcard-header").show();
            $(".expandedcard_modal").css({ 'overflow-y': 'auto' }).scrollTop(0)


            $clone.css({
                'transition': 'top 400ms cubic-bezier(0.16,1,0.3,1), left 400ms cubic-bezier(0.16,1,0.3,1), width 400ms cubic-bezier(0.16,1,0.3,1), height 400ms cubic-bezier(0.16,1,0.3,1), transform 400ms cubic-bezier(0.16,1,0.3,1)',
                'top': '50%',
                'left': '50%',
                'transform': 'translate(-50%, -50%)',
                'height': 'calc(100vh - 100px)',
                'max-width': '1075px',
                'width': vpWidth > 768 ? '70%' : '95%',
                'box-shadow': '0px 2px 41px -4px rgb(40 41 61 / 23%), 0px 4px 10px rgb(34 34 35 / 23%)'
            });
            $('body').css({
                "overflow-y":"hidden"
            })
            
            $(".expandedcard_content").removeClass("d-none");
            // Start slightly scaled down and transparent, then let the content
            // follow the container morph a beat later so the reveal feels like a
            // single surface transformation instead of a hard content swap.
            var $content = $(".expandedcard_content");
            setImportant($content, {
                'transition': 'none',
                'transform-origin': 'center top',
                'opacity': '0',
                'transform': 'scale(0.97) translateY(8px)',
                'overflow-y': vpWidth > 768 ? 'hidden' : 'auto',
                'overflow-x': 'hidden'
            });
            // Force reflow so the transition below actually animates from this state.
            void $content[0]?.offsetWidth;
            setImportant($content, {
                transition: 'transform 360ms cubic-bezier(0.2,0,0,1) 110ms, opacity 180ms linear 110ms',
                'opacity': '1',
                'transform': 'scale(1) translateY(0)'
            });

            setImportant($(".card-color-line"), { 'transition': 'none', 'opacity': '1' });
            $(".expandCardBack").fadeIn(250);
        } else {
            $('.expandCardBack').click();
        }

    });

    $(document).on('click', '.extend-modal-close', function (e) {
        isExpanded = false
        $('.expandCardBack').click();
        $('body').css({
            "overflow-y": "auto"
        })
    });

    $(document).on('click', '.header-modal-mark', function (e) {
        if(!$('.expandCardBack').hasClass("d-none")) {
            $('.expandCardBack').click();
            $('body').css({
                "overflow-y":"auto"
            })
        }
    })
    
    $(document).on('click', '.expandCardBack', function (e) {
        if (cloneflipped) {
            isExpanded = false
            $(".expandCardBack").fadeOut(320);

            // For the return transition, keep the content close to full size and
            // fade it away near the end. This reads more like a container
            // transform than a tiny thumbnail shrinking inside the modal.
            var $content = $(".expandedcard_content");

            setImportant($clone,{
                'transition': 'all 400ms cubic-bezier(.08,.02,.7,-0.27)',
                'top': lastelement.top + 'px',
                'left': lastelement.left + 'px',
                'height': '97.5px',
                'width': '190px',
                'transform': 'unset',
                'box-shadow': 'unset'
            });
            $('body').css({
                "overflow-y":"auto"
            })

            setImportant($content, {
                'transition':
                    'transform 420ms cubic-bezier(0.16,1,0.3,1), opacity 140ms linear 190ms',
                'transform-origin': 'top center',
                'transform': 'scale(0.985)',
                'opacity': '0'
            });
            setImportant($(".card-color-line"), {
                'transition': 'height 400ms cubic-bezier(0.16,1,0.3,1)'
            });
            $(".expandedcard_modal").css({ 'overflow-y': 'hidden' })

            // clean up the URL without adding a history entry
            window.history.replaceState({}, '', window.location.pathname + window.location.hash.split('?')[0]);
        }
    });

    window.addEventListener('popstate', function (e) {
        const manager = getModalBackManager();

        // A nested modal consumed this back press; don't close expanded job yet.
        if (manager.depth > 0 || manager.ignoreNextPop) {
            manager.ignoreNextPop = false;
            return;
        }

        if (isExpanded || e.state?.jobCardOpen) {
            isExpanded = false;
            $('.expandCardBack').click();
            $('body').css({ "overflow-y": "auto" });
        }
    });
}